module.exports = __webpack_public_path__ + "images/browser-logo-firefox-cfd87a8f62ae37a34dab9f4b5c79b168.png";